export default function(evaluation) {
  return {
    START: `/evaluation-event-partner/${evaluation.id}/start`,
    OUTCOME: `/evaluation-event-partner/${evaluation.id}/outcome`,
    RECOMMEND: `/evaluation-event-partner/${evaluation.id}/recommend`,
    END: `/evaluation-event-partner/${evaluation.id}/end`,
    EVENT_VIEW: `/event/${evaluation.data.eventId}/view`,
  };
};
